import { render, staticRenderFns } from "./HomepageVideo.vue?vue&type=template&id=65688dcd&scoped=true&"
import script from "./HomepageVideo.vue?vue&type=script&lang=js&"
export * from "./HomepageVideo.vue?vue&type=script&lang=js&"
import style0 from "./HomepageVideo.vue?vue&type=style&index=0&id=65688dcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65688dcd",
  null
  
)

export default component.exports